import { CouponStepForm } from "../../models/api/codegen/code";
import { CouponEvent } from "../../store/spirs/reducers/couponReducer";


export type SelectionIdWithOdds = {
    selectionId: number;
    odds?: number;
}


export type CompareEventOutput = {
    oddsChanged: boolean;
    outputEvents: CouponEvent[];
    allEventsDirection?: 'up' | 'down' | 'both';
}

function generateArray(type: CouponStepForm['type'], steps: Array<CouponStepForm>): SelectionIdWithOdds[] | null {
    switch (type) {
        case "EXPRESS":
        case "SYSTEM":
            if (steps[0].events) {
                return steps[0].events.map(el => ({
                        selectionId: el.selectionId,
                        odds: el.odds
                    }))
            } else {
                console.log(`There is no any coupon events from response for  ${steps[0].type} type...`);
                return null;
            }
        case "ORDINAR":
            return steps.reduce(
                (acc: SelectionIdWithOdds[], el: CouponStepForm) => {

                    if (el.events) {
                        acc.push({
                            selectionId: el.events[0].selectionId,
                            odds: el.events[0].odds
                        });
                    }
                    return acc;

                },
                [] as SelectionIdWithOdds[]
            );
        default:
            return null;
    }
}


export function compareEvents(type: CouponStepForm['type'], steps: Array<CouponStepForm>, couponEvents: CouponEvent[]): CompareEventOutput {

    const newarrayComparedWith = generateArray(type, steps);

    if (!newarrayComparedWith) {
        return {
            oddsChanged: false,
            outputEvents: couponEvents,
        }
    }

    let oddsChanged = false;
    let allEventsDirection: CompareEventOutput['allEventsDirection'] = undefined;

    const outputEvents = couponEvents.map(el => {
        const matchedEl = newarrayComparedWith.find(newEl => newEl.selectionId === el.selectionId);

        if (matchedEl && matchedEl.odds && matchedEl.odds !== el.odds) {
            oddsChanged = true;

            const isUp = (matchedEl.odds > el.odds);
            switch (allEventsDirection) {
                case undefined:
                    allEventsDirection = isUp ? 'up' : 'down';
                    break;
                case "up":
                    allEventsDirection = isUp ? 'up' : 'both';
                    break;
                case "down":
                    allEventsDirection = isUp ? 'down' : 'both';
                    break;
            }

            return {
                ...el,
                direction: isUp ? "up" : 'down' as 'up' | 'down',
                odds: matchedEl.odds
            };
        } else {
            return el;
        }
    });

    return {
        oddsChanged: oddsChanged,
        outputEvents: outputEvents,
        allEventsDirection: allEventsDirection
    };
}
